(function () {
	const $flags = document.querySelector('.js-multilanguage-flags');

	if ($flags) {
		const $flagsItems = document.querySelectorAll('.js-multilanguage-flags-item');
		const $selectedFlag = document.querySelector('.js-multilanguage-selected-flag');

		$flags.addEventListener('click', function () {
			const lang = $selectedFlag.dataset.lang;
			const flagItems = [ ...$flagsItems];

			flagItems.forEach($item => $item.classList.remove('hide'));
			flagItems.find($item => $item.dataset.lang === lang).classList.add('hide');

			$flags.classList.toggle('open');
		});

		$flagsItems.forEach(function ($activeItem) {
			$activeItem.addEventListener('click', function () {


				$flagsItems.forEach(function ($item) {
					$item.classList.remove('active');
				});

				$selectedFlag.dataset.lang = $activeItem.dataset.lang;
				$selectedFlag.src = $activeItem.src;

				$flags.classList.toggle('open');
			});
		});
	}

})();



// WEBPACK FOOTER //
// ./app/blocks/header/header.js